import toast from 'react-hot-toast';

export async function copyToClipboard(text: string, successMessage: string = 'Copied to clipboard'): Promise<boolean> {
  if (!text) return false;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      if (successMessage) toast.success(successMessage);
      return true;
    }
  } catch (err) {
    // Fall through to fallback below
  }

  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    textArea.setAttribute('readonly', '');
    document.body.appendChild(textArea);
    textArea.select();
    textArea.setSelectionRange(0, 99999);

    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (successful) {
      if (successMessage) toast.success(successMessage);
      return true;
    }
  } catch (err) {
    console.error('Copy to clipboard failed:', err);
  }

  toast.error('Failed to copy text');
  return false;
}
